<template>
  <el-container>
    <el-main>
      <el-row type="flex" justify="space-start" :gutter="20">
        <el-col :span="24" >
          <el-card class="box-card">
            <h4 class="card-title">Your Invoices</h4>
            <div class="card-header">
              <!--<invoice-filter
                :filter="invoices"
                v-model="invoices"
                v-on:loading="loadingInvoices = $event"
                v-on:update:invoices="invoices = $event"
              ></invoice-filter>-->

              <div class="card-content">

                <el-row style="margin-top:30px; margin-bottom: 10px">

                
              </el-row>
              <div class="table-responsive">
                <data-tables-server 
                  class="el-table table-shopping el-table--fit el-table--scrollable-x el-table--enable-row-hover el-table--enable-row-transition" 
                  style="width: 100%" 
                  :data="invoices" 
                  :tool-bar="false" 
                  :current-page="1" 
                  :total="total"
                  :loading="loadingInvoices"
                  :page-size="10"
                  @query-change="getInvoices"
                  :pagination-props="{ pageSizes: [5, 10, 15, 20, 50] }">

                  <el-table-column label="ID" min-width="10">
                    <template slot-scope="props">{{props.row.id}}</template>
                  </el-table-column>

                  <el-table-column label="Classroom Total" min-width="10">
                    <template slot-scope="props" v-if="tutors.length > 0">{{props.row.classRoomTotal | currentyCodeToSymbol(tutors[0].currency)}}</template>
                  </el-table-column>

                  <el-table-column label="Bonus Total" min-width="10">
                    <template slot-scope="props" v-if="tutors.length > 0">{{props.row.bonusTotal | currentyCodeToSymbol(tutors[0].currency)}}</template>
                  </el-table-column>

                  <el-table-column label="Invoice Total" min-width="10">
                    <template slot-scope="props" v-if="tutors.length > 0">{{props.row.invoiceTotal | currentyCodeToSymbol(tutors[0].currency)}}</template>
                  </el-table-column>

                  <el-table-column label="Invoice Paid" min-width="10">
                    <template slot-scope="props">
                      <small class="label label-success" v-if="props.row.isPaid === 1">Yes</small>
                      <small class="label label-danger" v-if="props.row.isPaid === 0">No</small>
                    </template>
                  </el-table-column>

                  <el-table-column label="Date Created" min-width="10">
                    <template slot-scope="props" v-if="props.row.dateCreated != ''">{{props.row.dateCreated | moment('DD MMM YYYY')}}</template>
                  </el-table-column>

                  <el-table-column label="Date Paid" min-width="10">
                    <template slot-scope="props" v-if="props.row.paidDate != ''">{{props.row.paidDate | moment('DD MMM YYYY')}}</template>
                  </el-table-column>

                  <el-table-column label="View" min-width="10">
                    <template slot-scope="props" v-if="props.row.sourceUrl != ''"><a :href="props.row.sourceUrl" :target="'_blank'"><i class="fa fa-download"></i></a></template>
                  </el-table-column>

                </data-tables-server>
              </div>
              </div>
            </div>
            <div class="card-content"></div>
          </el-card>
        </el-col>
      </el-row>
    </el-main>
  </el-container>
</template>
<script>
//import InvoiceFilter from "../UIComponents/InvoiceFilter.vue";
//import VenueFilter from "../UIComponents/VenueFilter.vue";
import api from "./api";
import _ from "lodash";
import gql from "graphql-tag";
import moment from "moment";
export default {
  data() {
    return {
      total: 0,
      countries: [],
      invoices: [],
      newInvoice: {},
      aggregate: {},
      total: 0,
      invoice: {},
      pickerOptions1: {
        shortcuts: [
          {
            text: "Last 24 hours",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "Last week",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "Two Weeks",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 14);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "Last month",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "3 months",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "6 months",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "1 year",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      filters: [ 
        {
          value: "ALL",
          prop: "venue"
        },
        {
          value: "20",
          prop: "numAttendees",
        },
        {
          value: [
            moment().subtract(1, "years").format("YYYY-MM-DD"),
            moment().format("YYYY-MM-DD")
          ],
          prop: "startDate"
        },
        {
          value: "_lte",
          prop: "numAttendees",
        },
      ],
      loadingInvoices: false,
      selectedCountry: "",
      selectedVenue: {},
      selectedTutor: {},
      tutor: {},
      tutors: [],
      venues: [],
      classVenues: [],
      venue: {},
      loading: false,
     
      rules: {
        meta: {'invoice-code':[
          { required: true, message: "Please add code", trigger: "blur" }
        ]}
      }
    };
  },
  methods: {

    getTutors() {

      var id = this.id
      this.loadingTutors = true;

      this.$apollo
      .query({
        query: gql`
        {
          Tutor(
            limit: 50,
            where: {id: {_eq: ${id}}}
          ) {
            id
            firstname
            lastname
            currency
            email
            rating
            isActive
            canLogin
            rating
            address {
              id
              line1
              line2
              country
              town
              phone
            }
          
          }
        }`,
        error(error) {
          this.error = JSON.stringify(error);
        }
      })
      .then(response => {
        this.tutors = response.data.Tutor;
        this.loadingTutors = false;
      });
    },

    getInvoices(queryInfo) {

      var id = this.id

      if ( queryInfo != undefined ) {

        var type = queryInfo.type;
        var page = queryInfo.page;
        var pageSize = queryInfo.pageSize;
        var orderDir = 'desc_nulls_last';
        var orderProp = 'paidDate';

        (queryInfo.type === 'page' || queryInfo.type === 'size' || queryInfo.type === 'sort') //&&
        //this.$message(`page: ${queryInfo.page}, pageSize: ${queryInfo.pageSize}, prop: ${queryInfo.sort.prop}, order: ${queryInfo.sort.order}`)

        
        if (queryInfo.sort.order === 'ascending') {
          orderDir = 'asc_nulls_last';
        } else if (queryInfo.sort.order === 'descending') {
          orderDir = 'desc_nulls_last';
        } else {}
        if (queryInfo.sort.prop != undefined) {
          orderProp = queryInfo.sort.prop;
        }

      } else {

        var type = 'init';
        var page = 1;
        var pageSize = 10;
        var orderDir = 'desc_nulls_last';
        var orderProp = 'paidDate';
        this.loadingInvoices = true;

      }

      this.$apollo
      .query({
        // desc_nulls_last filters out any null data
        query: gql`
          {
            TutorInvoice(
              limit: ${pageSize}, 
              offset: ${(page - 1) * pageSize},
              order_by: {${orderProp}:${orderDir}},
              where: { 
                  _and: [
                    { tutorId: {_eq: "${id}"} }
                  ]
                }
            ) {
              id
              tutorId
              bonusTotal
              classRoomTotal
              dateCreated
              dateUpdated
              invoiceDate
              invoiceTotal
              isPaid
              paidDate
              sourceUrl
            }
            TutorInvoice_aggregate(
              where: { 
                 _and: [
                    { tutorId: {_eq: "${id}"} }
                  ]
                }
            ) {
              aggregate {
                count
              }
            }
          }
        `,
        // can get error if needed
        error(error) {
          this.error = JSON.stringify(error);
        }
      })
      .then(response => {
        this.invoices = response.data.TutorInvoice;
        this.aggregate = response.data.TutorInvoice_aggregate.aggregate;
        this.total = response.data.TutorInvoice_aggregate.aggregate.count;
        this.loadingInvoices = false;
      });
    }
  },
  mounted() {
    this.getTutors();
    this.getInvoices();
  },
  computed: {
    id(){
      const token = localStorage.getItem('vuex')
      const parsed = JSON.parse(token)
      const id = parsed['auth']['id']
      console.log('id: ', id);
      return id
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/Tutor/Invoices.vue